import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { menuItemsForAdmin, menuItemsForCompanyIssuer, menuItemsForIssuer, menuItemsForUser } from '../menuItems';
import { styled } from '@mui/material/styles';
import { useAuth } from '../../../contexts/authContext';

const useStyles = makeStyles((theme) => ({
  listItem: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  activeListItem: {
    backgroundColor: theme.palette.action.selected,
  },
  listItemText: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  activeLink: {
    backgroundColor: theme.palette.action.selected,
  },
}));

const CustomListItemIcon = styled(ListItemIcon)(({ theme, isActive }) => ({
  color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
}));

const SideNavBar = ({ role, handleNavigation, toggleDrawer }) => {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useAuth();
  const createdByIssuerID = user.CreatedByIssuerID;

  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    if (role === 'Admin') {
      setMenuItems(menuItemsForAdmin);
    } else if (role === 'Issuer' && createdByIssuerID) {
      setMenuItems(menuItemsForCompanyIssuer);
    } else if (role === 'Issuer' && !createdByIssuerID) {
      setMenuItems(menuItemsForIssuer);
    } else {
      setMenuItems(menuItemsForUser);
    }
  }, [role]);

  // useEffect(() => {
  //   if (role.includes("Admin")) {
  //     setMenuItems(menuItemsForAdmin);
  //   } else if (role.includes("Issuer")) {
  //     setMenuItems(menuItemsForIssuer);
  //   } else {
  //     setMenuItems(menuItemsForUser);
  //   }
  // }, [role]);

  const basePath = location.pathname.split('/')[1] || '';

  const handleItemClick = (path) => {
    handleNavigation(path);
    toggleDrawer && toggleDrawer();
  };

  return (
    <List>
      {menuItems.map((item) => {
        const fullPath = `/${basePath}/${item.path}`;
        return (
          <ListItem
            key={item.text}
            component={NavLink}
            to={fullPath}
            className={`${classes.listItem} ${location.pathname === fullPath ? classes.activeListItem : ''}`}
            exact
            onClick={() => handleItemClick(fullPath)}
          >
            <CustomListItemIcon isActive={location.pathname === fullPath}>
              {item.icon}
            </CustomListItemIcon>
            <ListItemText primary={item.text} className={classes.listItemText} />
          </ListItem>
        );
      })}
    </List>
  );
};

export default SideNavBar;
